import React from 'react';
import { Mail, MapPin, Phone, Facebook, Twitter, Instagram } from 'lucide-react';
import './Footer.css';
import logo from '../assets/logo.jpg';


const Footer = () => {
    return (
        <footer className="footer-container">
            <div className="footer-content">
                <div className="footer-section">
                    <div className="footer-brand">
                        <img src={logo} alt="Logo" className="footer-logo" />
                    </div>
                </div>

                <div className="footer-section">
                    <h4 className="footer-heading">Quick Links</h4>
                    <ul className="footer-links">
                        <li><a href="/">Home</a></li>
                        <li><a href="/about">About</a></li>
                        <li><a href="/services">Services</a></li>
                        <li><a href="/contact">Contact</a></li>
                        <li><a href="/privacy">Privacy Policy</a></li>
                    </ul>
                </div>

                <div className="footer-section">
                    <h4 className="footer-heading">Contact Info</h4>
                    <div className="contact-info">
                        <div className="contact-item">
                            <MapPin size={18} />
                            <span>
                                <p>Uniaariv Consultancy Services</p>
                                <p>204, New Vrindavan, Church Road,</p>
                                <p>Vile Parle (West), Mumbai 400 056.</p>
                            </span>
                            </div>
                        <div className="contact-item">
                            <Phone size={18} />
                            <span>+919619 123234, 99205 41001</span>
                        </div>
                        <div className="contact-item">
                            <Mail size={18} />
                            <span>contact@uniaariv.com</span>
                        </div>
                    </div>
                </div>

                <div className="footer-section">
                    <h4 className="footer-heading">Follow Us</h4>
                    <div className="social-links">
                        <a href="https://facebook.com" aria-label="Facebook">
                            <Facebook size={20} />
                        </a>
                        <a href="https://twitter.com" aria-label="Twitter">
                            <Twitter size={20} />
                        </a>
                        <a href="https://instagram.com" aria-label="Instagram">
                            <Instagram size={20} />
                        </a>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>© {new Date().getFullYear()} Uniaariv. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;